import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../../../services/admin/admin.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RestaurantStatus } from '../../../interfaces/restaurant';

type AddRestaurantForm = {
  name: FormControl<string>;
  email: FormControl<string>;
  password: FormControl<string>;
  language: FormControl<string>;
  province: FormControl<string | null>;
  dwallGroupId: FormControl<number | null>;
  status: FormControl<RestaurantStatus | null>;
};

@Component({
  selector: 'app-add-restaurant',
  templateUrl: './add-restaurant.component.html',
  styleUrls: ['./add-restaurant.component.scss']
})
export class AddRestaurantComponent {

  public loading = false;
  public addRestaurantForm: FormGroup<AddRestaurantForm> = this.generateForm();
  public language = localStorage.getItem('lang') ?? this.translate.currentLang;
  public readonly restaurantStatuses: RestaurantStatus[] = ['active', 'inactive', 'test'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { chainId: number },
    public dialogRef: MatDialogRef<any>,
    private translate: TranslateService,
    private admin: AdminService,
  ) { }

  private generateForm(): FormGroup<AddRestaurantForm> {
    return new FormGroup({
      name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      email: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] }),
      password: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(30)]
      }),
      language: new FormControl('en-CA', { nonNullable: true, validators: [Validators.required] }),
      province: new FormControl<string | null>(null),
      dwallGroupId: new FormControl<number | null>(null),
      status: new FormControl<RestaurantStatus | null>(null)
    });
  }

  addRestaurant(form: FormGroup<AddRestaurantForm>): void {
    this.loading = true;
    const value = form.getRawValue();

    const newRestaurantInfo = {
      chainId: this.data.chainId,
      name: value.name,
      email: value.email,
      password: value.password,
      language: value.language,
      province: value.province,
      dwallGroupId: value.dwallGroupId,
      status: value.status
    };

    this.admin.addRestaurant(newRestaurantInfo).subscribe(
      (data) => {
        this.dialogRef.close(data);
        this.loading = false;
      },
      () => this.loading = false
    );
  }
}
